import React from 'react';

export default function ContactUs() {
  return (
    <section style={{padding: '3rem 1rem', maxWidth: 600, margin: '0 auto'}}>
      <h1 style={{textAlign: 'center', fontSize: '2.2rem', marginBottom: '2rem'}}>Contact Us</h1>
      <p style={{fontSize: '1.1rem', marginBottom: '1.5rem'}}>
        For support, feedback, or business inquiries, please reach out to us:
      </p>
      <ul style={{listStyle: 'none', padding: 0, fontSize: '1.1rem'}}>
        <li><strong>Email:</strong> <a href="mailto:support@justfeasible.com">support@justfeasible.com</a></li>
        <li><strong>Location:</strong> Herndon, VA, USA</li>
      </ul>
      <p style={{marginTop: '2rem', color: '#555'}}>
        We value your feedback and will respond as soon as possible.
      </p>
    </section>
  );
}
